import { Component, HostListener, Input, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Subject, switchMap, takeUntil, timer } from 'rxjs';
import { TemplateService } from '../../../../services/template.service';

@Component({
    selector: 'app-heartbeat',
    imports: [],
    templateUrl: './heartbeat.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './heartbeat.component.scss'
})
export class HeartbeatComponent implements OnDestroy {
  @Input() idcustom: string | undefined;
  @Input() lockedBy: string | undefined;
  @Input() type: string = "email";

  // a subject that emits whenever user activity is detected
  private userActivity$ = new Subject<void>();
  private _destroy$ = new Subject<void>();

  constructor(private templateService: TemplateService) {
    // each time userActivity$ emits, cancel the previous timer and start a new one
    this.userActivity$
      .pipe(
        switchMap(() => timer(5 * 60 * 1000))
      )
      .pipe(takeUntil(this._destroy$))
      .subscribe(() => {
        // this code runs after 5 minutes of inactivity
        console.log('User has been inactive for 5 minutes');
        // unlock the template
        if (this.idcustom && this.lockedBy) {

          this.templateService.sendLockBy(this.idcustom, {
            name: '',
            username: '',
          })
            .pipe(takeUntil(this._destroy$))
            .subscribe({
              next: (response) => {
                // console.log(response)
              },
              error: (error) => {
                console.error('Change lock by error: ', error);
              },
            });
        }

      });
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  @HostListener('document:mousemove')
  @HostListener('document:keydown')
  detectActivity() {
    this.userActivity$.next();
  }


}
